import { customApiCall } from "../utils/api";

const getApiList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.[key])) return data[key];
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

const getExecutionsUrl = (projectId, path = "") =>
  `${process.env.REACT_APP_API_URL_2}api/projects/${projectId}/sound-emission/executions${path}`;

const getRequired = async (url) => {
  const data = await customApiCall.get({ url });
  if (data === undefined) throw new Error("Sound emission request failed.");
  return data;
};

export const getSoundEmissionExecutions = async (projectId) => {
  const data = await getRequired(getExecutionsUrl(projectId));
  return getApiList(data, "executions");
};

export const getSoundEmissionExecutionData = async (projectId, batchId) => {
  const baseUrl = getExecutionsUrl(projectId, `/${batchId}`);
  const [candidatesData, receiversData] = await Promise.all([
    getRequired(`${baseUrl}/candidates`),
    getRequired(`${baseUrl}/receivers`),
  ]);

  return {
    batchId,
    candidates: getApiList(candidatesData, "candidates"),
    receivers: getApiList(receiversData, "receivers"),
  };
};
